import { render, staticRenderFns } from "./templateDetail.vue?vue&type=template&id=dfb694fe&scoped=true"
import script from "./templateDetail.vue?vue&type=script&lang=ts"
export * from "./templateDetail.vue?vue&type=script&lang=ts"
import style0 from "./templateDetail.vue?vue&type=style&index=0&id=dfb694fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfb694fe",
  null
  
)

export default component.exports